import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { getUserType } from 'redux/slices/userSlice';
import Clue from 'shared/ui/Clue';

import { ICL, WordLettersToWork, TaskKeysType, WordStressTask } from '../../../shared/types';
import StudentTaskWrapper from '../StudentTaskWrapper';

interface StudentWordStressTaskProps extends WordStressTask {
  icl: ICL | null;
  handleChangeTaskByKey: (id: string, key: TaskKeysType, value: string[] | string | boolean | WordStressTask[]) => void;
  saveTaskAnswer: (id: string) => Promise<void>;
  hw?: boolean;
  preview?: boolean;
  studentName?: string;
  index: number;
}

export default function StudentWordStressTask({
  icl,
  text,
  subText,
  answer,
  hasAnswer,
  hasStar,
  checkedAt,
  completedAt,
  handleChangeTaskByKey,
  id,
  hasPhoto,
  answersPhotos,
  saveTaskAnswer,
  deadline,
  audioUrl,
  videoUrl,
  taskPhotos,
  editedAnswerPhotos,
  hw,
  pdfUrl,
  wordUrl,
  studentPdfUrl,
  studentWordUrl,
  preview,
  words,
  studentName,
  index,
}: StudentWordStressTaskProps) {
  const userType = useSelector(getUserType);

  const changeFormikWord = (wordId: string, letterId: string) => {
    const changedWords = words.map(word => {
      if (word.id === wordId) {
        const changedWordLettersToWork = word.wordLettersToWork.map(wordLetter => {
          if (wordLetter.id === letterId) {
            const bgImg = wordLetter.bgImg === 'apostrophe' ? '' : 'apostrophe';

            return { ...wordLetter, bgImg } as WordLettersToWork;
          }

          return wordLetter;
        });

        return {
          ...word,
          wordLettersToWork: changedWordLettersToWork,
        };
      }

      return word;
    });

    handleChangeTaskByKey(id, 'words', changedWords);
  };

  const areStudentAnswers = words.every(word => word.wordLettersToWork.some(letter => letter.bgImg === 'apostrophe'));
  const isDisabledSubmitButton = !areStudentAnswers || !!checkedAt || !!completedAt;

  const isStudent = userType === 'Student';
  const isButtonDisabled = !!checkedAt || !!completedAt || !isStudent || !!preview;

  return (
    <StudentTaskWrapper
      icl={icl}
      taskText={text}
      answersPhotos={answersPhotos}
      id={id}
      handleChangeTaskByKey={handleChangeTaskByKey}
      checkedAt={checkedAt}
      hasPhoto={hasPhoto}
      completedAt={completedAt}
      saveTaskAnswer={saveTaskAnswer}
      deadline={deadline}
      audioUrl={audioUrl}
      answer={answer}
      hasAnswer={hasAnswer}
      hasStar={hasStar}
      videoUrl={videoUrl}
      taskPhotos={taskPhotos}
      editedAnswerPhotos={editedAnswerPhotos}
      hw={hw}
      pdfUrl={pdfUrl}
      wordUrl={wordUrl}
      studentPdfUrl={studentPdfUrl}
      studentWordUrl={studentWordUrl}
      preview={preview}
      subText={subText}
      isDisabledSubmitButton={isDisabledSubmitButton}
      studentName={studentName}
      isSubmitButton
      index={index}
    >
      <div className="!py-5 md:!py-8">
        <Clue text="studentWordStressHint" className="!mb-5 md:!mb-6" />

        <div className="!mb-3 grid !gap-3 md:grid-cols-2">
          {words.map(word => (
            <ul className="flex !gap-1" key={word.id}>
              {word.wordLettersToWork.map(wordLetter => (
                <li key={wordLetter.id} className="flex flex-col items-center justify-center">
                  {wordLetter.bgImg === 'apostrophe' && <div className="!mb-0 h-1 w-1">´</div>}

                  <button
                    onClick={() => changeFormikWord(word.id, wordLetter.id)}
                    className={cn('text-[18px] font-medium', wordLetter.bgImg !== 'apostrophe' ? '!mt-[4px]' : '')}
                    disabled={isButtonDisabled}
                  >
                    {wordLetter.letter}
                  </button>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </StudentTaskWrapper>
  );
}
